/**
 * Shows "X Bills Pending Sync" indicator when offline bills are waiting to sync (desktop app only).
 * Visible only when window.electronAPI exists and pendingCount > 0.
 */

import React from 'react';
import { Chip, Box, Tooltip } from '@mui/material';
import { CloudUpload as SyncIcon } from '@mui/icons-material';
import { useOffline } from '../../context/OfflineContext';

export default function OfflineSyncIndicator() {
  const { pendingCount, isSyncing, syncNow } = useOffline();

  if (!window.electronAPI || pendingCount <= 0) return null;

  const label = isSyncing
    ? 'Syncing...'
    : `${pendingCount} Bill${pendingCount > 1 ? 's' : ''} Pending Sync`;

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', mr: 1 }}>
      <Tooltip title={isSyncing ? 'Syncing offline bills to server...' : 'Click to sync offline bills now'}>
        <Chip
          icon={<SyncIcon sx={{ fontSize: 18, color: 'inherit' }} />}
          label={label}
          size="small"
          color="warning"
          variant="filled"
          onClick={isSyncing ? undefined : syncNow}
          disabled={isSyncing}
          sx={{
            cursor: isSyncing ? 'default' : 'pointer',
            fontWeight: 600,
            '& .MuiChip-icon': { color: 'inherit' }
          }}
        />
      </Tooltip>
    </Box>
  );
}
